import { useTranslations } from 'next-intl'
import { useChinaDetector } from '../common/region-locale'

type Section1 = {
  imageTitle: string
  subTitle: string
  backgroundImage: string
}
type Section2 = {
  video: string
  backgroundVideo: string
}
type Section3 = {
  title: string
  subTitle: string
  robotFrontImage: string
  robotBackImage: string
  spec: Array<[string, string]>
}
type Section4 = {
  title: string
  subTitle: string
  handFrontImage: string
  handBackImage: string
  spec: Array<[string, string]>
}

type Section5 = {
  title: string
  statementTitle: string
  d9Image: string
  spec: Array<[string, string | string[]]>
  statement: string[]
}
type Section6 = {
  title: string
  subTitle: string
  images: string[]
}

export function useD9() {
  const t = useTranslations()
  const inChina = useChinaDetector()
  const locale = inChina ? 'zh' : 'en'

  const section1: Section1 = {
    imageTitle: 'https://cdn.pudutech.com/official-website/d9/section1_title.svg',
    subTitle: t('Section1.SubTitle'),
    backgroundImage: 'https://cdn.pudutech.com/official-website/d9/section1_bg.webp',
  }
  const section2: Section2 = {
    video: 'https://cdn.pudutech.com/official-website/d9/PUDU_D9_' + locale + '.mp4',
    backgroundVideo: 'https://cdn.pudutech.com/official-website/d9/section2_bg.mp4',
  }
  const section3: Section3 = {
    title: t('Section3.Title'),
    subTitle: t('Section3.SubTitle'),
    robotFrontImage: 'https://cdn.pudutech.com/official-website/d9/section3_front_' + locale + '.webp',
    robotBackImage: 'https://cdn.pudutech.com/official-website/d9/section3_back_' + locale + '.webp',
    spec: t.raw('Section3.SpecParameters'),
  }
  const section4: Section4 = {
    title: t('Section4.Title'),
    subTitle: t('Section4.SubTitle'),
    spec: t.raw('Section4.SpecParameters'),
    handBackImage: 'https://cdn.pudutech.com/official-website/d9/section4_back_hand.webp',
    handFrontImage: 'https://cdn.pudutech.com/official-website/d9/section4_front_hand.webp',
  }
  const section5: Section5 = {
    title: t('Section5.Title'),
    statementTitle: t('Section5.StatementTitle'),
    d9Image: 'https://cdn.pudutech.com/official-website/d9/d9.webp',
    spec: t.raw('Section5.SpecParameters'),
    statement: t.raw('Section5.Statement'),
  }
  const section6: Section6 = {
    title: t('Section6.Title'),
    subTitle: t('Section6.SubTitle'),
    images: [
      'https://cdn.pudutech.com/official-website/d9/section6_1.webp',
      'https://cdn.pudutech.com/official-website/d9/section6_2.webp',
      'https://cdn.pudutech.com/official-website/d9/section6_3.webp',
    ],
  }

  return {
    section1,
    section2,
    section3,
    section4,
    section5,
    section6,
  }
}
